import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { ProviderTournament } from 'react-easyrocket';
import { CONTENT_URL } from 'src/api';
import { Button } from 'src/components/Buttons/Button';
import { ModalWrapper } from 'src/components/ModalWrapper';
import { useModalContext } from 'src/hooks/useModalContext';
import { useRoute } from 'src/router/hooks';

const NewTournamentModal = () => {
  const { t } = useTranslation();
  const { modalProps, closeModal } = useModalContext<ProviderTournament>();
  const navigate = useNavigate();
  const { ROUTE } = useRoute();

  return (
    <ModalWrapper isTransparentBg>
      <div className="">
        <img
          src={`${CONTENT_URL}${modalProps.image}`}
          alt={modalProps.title}
          className="z-0 relative max-h-[200px]"
        />
        <div className="p-[20px] bg-tp_card_bg z-[1] relative">
          <p className="text-center text-tp_title_games text-[20px] font-bold mb-[20px]">
            {modalProps?.title}
          </p>
          <p className="text-center text-tp_card_description text-[16px] font-bold mb-[20px]">
            {modalProps?.description}
          </p>
          <Button
            title={t('general.participate') as string}
            label={t('general.participate') as string}
            mode="button-primary"
            className="!w-full max-w-[400px] mb-[20px]"
            onClick={() => {
              navigate(ROUTE.NETWORK_TOURNAMENT.get(modalProps.code), {
                state: { id: modalProps.code }
              });
              closeModal();
            }}
          />
          <div className="flex gap-3">
            <Button
              title={t('general.cancel') as string}
              label={t('general.cancel') as string}
              mode="button-secondary"
              className="m-auto"
              onClick={() => {
                closeModal();
              }}
            />
            <Button
              title={t('general.readMore') as string}
              label={t('general.readMore') as string}
              mode="button-secondary"
              className="m-auto"
              onClick={() => {
                navigate(ROUTE.NETWORK_TOURNAMENT.get(modalProps.code), {
                  state: { id: modalProps.code }
                });
                closeModal();
              }}
            />
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default NewTournamentModal;
